import { Routes, RouterModule } from '@angular/router';
import { ShoppingCart } from './shopping-cart.component'

const shoppingcartRoutes: Routes = [
	{ path: 'shopping-cart', component: ShoppingCart }
];

export const shoppingcartRouting = RouterModule.forChild(shoppingcartRoutes);



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart.routing.ts